import './style.css';
import Button from "../../../Buttons/Button";
import React, { FormEvent, useCallback, useEffect, useRef, useState } from "react";
import { secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { IGroupProps } from "../../../../interfaces";
import { Column } from "../../../../style";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { ContainerButtons, ContainerForm, Form } from "./style";
import { GenericForm, IGenericFormRefProps } from '../../../GenericForm';
import { useForm } from 'react-hook-form';

interface IFormChangePassword {
  onCancel: Function;
  onSave: Function;
  defaultData?: {
    id: string;
    title: string;
    subject: string;
    type: string;
    text: string;
    name: string;
  } | null;
}

export const FormChangePassword: React.FC<IFormChangePassword> = (props) => {
  const { onSave, defaultData } = props;

  const { theme, notify } = useGlobal();
  const { api } = useApi();

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
  } = useForm({
    mode: "all",
  });

  const _form = watch();

  const form_ref = useRef<IGenericFormRefProps>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  const { user } = useApi();

  const onSubmit = useCallback(async () => {
    const newPassword = _form?.new_password
    const oldPassword = _form?.old_password

    setLoading(true);
    try {
      await api.put(`/users/change-password/${user.id}`, { oldPassword, newPassword, userId: user.id });

      notify('Senha alterada com sucesso!', "success");

      onSave();
    } catch (err: any) {
      const error = err.response ? err.response?.data : "SERVER ERROR";

      if (error.field) {
        setError(error.field, { type: "manual", message: error.detail });
      } else {
        notify('Erro ao trocar senha, tente novamente mais tarde!', "alert");
      }
    }

    setLoading(false);
  }, [api, errors, _form]);

  const handleStopPropagation = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e?.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    [handleSubmit, onSubmit, form_ref, _form, api]
  );

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "old_password",
            label: "Senha antiga",
            type: "input",
            required: !defaultData?.id,
            isPassword: true,
          },
        ],
        [
          {
            name: "new_password",
            label: "Nova senha",
            type: "input",
            required: !defaultData?.id,
            isPassword: true,
          },
        ],
        [
          {
            name: "confirmation_new_password",
            label: "Confirmação da nova senha",
            type: "input",
            required: !defaultData?.id,
            isPassword: true,
            validate: async (value: any) => {
              const password = watch("new_password");
              if (value !== password) return "As senhas não conferem.";
              return true;
            },
          },
        ],
      ],
    },
  ];

  return (
    <>
      <Column style={{ flex: 1, overflow: "auto", padding: 20 }}>
        <ContainerForm open>
          <Form onSubmit={handleStopPropagation}>
            <GenericForm
              ref={form_ref}
              groups={groups}
              _form={_form}
              control={control}
              trigger={trigger}
              errors={errors}
              setValue={setValue}
              register={register}
              key={errors?.toString()}
            />
            <button
              className="display-none"
              type="submit"
              ref={submitButtonRef}
            />
          </Form>
        </ContainerForm>
      </Column>

      <ContainerButtons theme={theme}>
        <Button
          onClick={() => submitButtonRef.current?.click()}
          background={secondary[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children={"Salvar"}
        />
      </ContainerButtons>

      <ModalLoading loading={loading} theme={theme} />
    </>
  );
};
